import http from "../http-common";

class AreaN1DataService {
  getAll() {
    return http.get("/arean1");
  }

  // arean1.js // SearchAreaN1.js
  getAreaN1ByDescr(condition, sortfield,sorttype) {
    return http.get(`/arean1/search/?nombrearea=${condition}&sortfield=${sortfield}&sorttype=${sorttype}`);
  }

  get(id) {
    return http.get(`/arean1/${id}`);
  }

  create(data) {
    return http.post("/arean1/newarean1", data);
  }

  update(id, data) {
    return http.put(`/arean1/${id}`, data);
  }

  delete(id) {
    return http.delete(`/arean1/${id}`);
  }

  deleteAll() {
    return http.delete(`/arean1`);
  }

  findById(id) {
    return http.get(`/arean1?id=${id}`);
  }
}

export default new AreaN1DataService();